import { ChevronUp } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconChevronTop(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ChevronUp />
    </IconWrapper>
  );
}
